import * as types from './actionTypes';
import PrivateAPIResource from "../services/PrivateAPIResource";
import { reset } from 'redux-form';

export function fetchCatalogs(page = 1, sortParams) {
    return dispatch => PrivateAPIResource.all('catalogs?page=' + page, sortParams)
        .then(catalogs => {
            dispatch({ type: types.FETCH_CATALOGS, catalogs });
        });
}

export function getCatalog(id) {
    return dispatch => PrivateAPIResource.get('catalogs', id).then(catalog => {
        dispatch({ type: types.GET_CATALOG, catalog});
    });
}

export function updateCatalog(id, data) {
    return dispatch => PrivateAPIResource.update('catalogs', id, data, true).then(catalog => {
        reset('catalog');
        dispatch({ type: types.UPDATE_CATALOG, catalog });
    });
}

export function deleteCatalog(id) {
    return dispatch => PrivateAPIResource.remove('catalogs', id).then(() => {
        dispatch({ type: types.DELETE_CATALOG, catalogId: id });
    });
}

export function createCatalog(catalog) {
    return dispatch => PrivateAPIResource.create('catalogs', catalog, true).then(catalog => {
        dispatch({ type: types.CREATE_CATALOG, catalog });
    });
}

export function cloneCatalog(origin) {
    return dispatch => PrivateAPIResource.clone('catalogs', origin.id).then(copy => {
        dispatch({ type: types.CLONE_CATALOG, catalog: copy });
    });
}

export function resetActiveCatalog() {
    return { type: types.RESET_ACTIVE_CATALOG };
}


// WEBPACK FOOTER //
// ./web/src/actions/catalogActions.js